import { EditOutlined } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import LearnMoreButton from "./LearnMore";
interface WhoWeAreProps {
  title: string;
  updateTitle?: (sectionId: string, newTitle: string) => void;
  isForSharing: boolean;
  whoWeAreData?: any;
  setWhoWeAreData?: any;
  sectionVisibility?: any;
  setSectionVisibility?: any;
  primaryColor?: string;
  accentColor?: string;
  canWrite?: boolean;
  canDelete?: boolean;
}

const WhoWeAre: React.FC<WhoWeAreProps> = ({
  title,
  whoWeAreData,
  setWhoWeAreData,
  sectionVisibility,
  setSectionVisibility,
  primaryColor,
  accentColor,
  isForSharing,
  canWrite = false,
  canDelete = false,
}) => {
  const [editHeading, setEditHeading] = useState(false);
  const [editBody, setEditBody] = useState(false);
  const [body, setBody] = useState("Body Text...");

  return (
    <div
      id="who-we-are"
      className="collapsible-section"
      style={{
        padding: "20px 60px",
        backgroundColor: "#fff",
        position: "relative",
      }}
    >
      {!isForSharing && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            minHeight: "45px",
          }}
          className={
            sectionVisibility?.["partner-success-metrics"] && !isForSharing
              ? "section-header"
              : ""
          }
        >
          {sectionVisibility["who-we-are"] && (
            <h3
              style={{
                fontSize: "30px",
                fontWeight: 500,
                border: "none",
                background: "transparent",
                margin: 0,
                wordBreak: "break-word",
              }}
            >
              {whoWeAreData?.title || "Who We Are"}
            </h3>
          )}

          <button
            onClick={() => {
              if (setSectionVisibility) {
                setSectionVisibility((prev: any) => ({
                  ...prev,
                  "who-we-are": !prev["who-we-are"],
                }));
              }
            }}
            className={
              sectionVisibility?.["partner-success-metrics"]
                ? "toggle-section-button"
                : ""
            }
            style={{
              position: "absolute",
              top: 20,
              right: 20,
              backgroundColor: "#fff",
              color: canWrite ? "#000000" : "rgba(0, 0, 0, 0.3)",
              boxShadow: "0 0 8px rgba(0,0,0,0.3)",
              padding: "6px 24px",
              border: "none",
              cursor: canWrite ? "pointer" : "not-allowed",
              width: "147px",
              height: "42px",
              borderRadius: "8px",
              fontSize: "15px",
              fontFamily: "Roboto, sans-serif",
            }}
            disabled={!canWrite}
          >
            {sectionVisibility?.["who-we-are"]
              ? "Show Section"
              : "Hide Section"}{" "}
          </button>
        </div>
      )}

      {!sectionVisibility?.["who-we-are"] && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "center",
            justifyContent: "center",
            height: "auto",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {editHeading && !isForSharing ? (
              <input
                type="text"
                value={whoWeAreData?.title}
                onChange={(e) => {
                  setWhoWeAreData((prev: any) => ({
                    ...prev,
                    title: e.target.value,
                  }));
                }}
                onBlur={() => setEditHeading(false)}
                autoFocus
                style={{
                  fontSize: "30px",
                  color: "#000",
                  backgroundColor: "transparent",
                  border: "none",
                  borderBottom: "1px solid #ccc",
                  fontWeight: "500",
                  outline: "none",
                  fontFamily: "Roboto, sans-serif",
                }}
                maxLength={40}
                disabled={!canWrite}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                }}
              >
                <h3
                  style={{
                    fontSize: "30px",
                    margin: 0,
                    fontWeight: "500",
                    letterSpacing: "-0.02rem",
                    width: "auto",
                    maxWidth: "750px",
                    wordWrap: "break-word",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    cursor: "default",
                  }}
                  title={title}
                >
                  {title}
                </h3>
                {!isForSharing && (
                  <button
                    onClick={() => setEditHeading(true)}
                    style={{
                      background: "#fff",
                      border: "1px solid #ccc",
                      cursor: `${canWrite ? "pointer" : "not-allowed"}`,
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "50%",
                      padding: "4px",
                      fontFamily: "Roboto, sans-serif",
                    }}
                    disabled={!canWrite}
                  >
                    <EditOutlined fontSize="small" />
                  </button>
                )}
              </div>
            )}
          </div>

          {editBody && !isForSharing ? (
            <textarea
              value={whoWeAreData?.description}
              autoFocus
              onChange={(e) => {
                setWhoWeAreData((prev: any) => ({
                  ...prev,
                  description: e.target.value,
                }));
              }}
              onBlur={() => setEditBody(false)}
              style={{
                width: "707px",
                height: "209px",
                border: "2px solid #BDBDBD",
                borderRadius: "4px",
                fontFamily: "Roboto",
                fontSize: "18px",
                lineHeight: "30px",
                outline: "none",
                cursor: canWrite || isForSharing ? "text" : "not-allowed",
              }}
              disabled={isForSharing || !canWrite}
              maxLength={300}
            />
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
              }}
            >
              <p
                style={{
                  margin: 0,
                  // fontWeight: "500",
                  letterSpacing: "-0.02rem",
                  width: "auto",
                  maxWidth: "750px",
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  cursor: "default",
                  fontSize: "18px",
                  lineHeight: "30px",
                  padding: "10px",
                }}
              >
                {whoWeAreData?.description || "Body Text..."}
              </p>
              {!isForSharing && (
                <button
                  onClick={() => setEditBody(true)}
                  style={{
                    background: "#fff",
                    border: "1px solid #ccc",
                    cursor: `${canWrite ? "pointer" : "not-allowed"}`,
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "50%",
                    padding: "4px",
                  }}
                  disabled={!canWrite}
                >
                  <EditOutlined fontSize="small" />
                </button>
              )}
            </div>
          )}
          {!(isForSharing && !whoWeAreData?.btnUrl?.trim()) && (
            <LearnMoreButton
              isForSharing={isForSharing}
              primaryColor={accentColor}
              link={whoWeAreData?.btnUrl}
              setLink={setWhoWeAreData}
              canWrite={canWrite}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default WhoWeAre;
